import { PaddingType } from 'common/types/styleTypes'
import {
  backgroundColorCss,
  mobileBackgroundColorCss,
  mobilePaddingsCss,
  paddingsCss,
} from 'common/utils/styleUtilsNew'
import styled, { css } from 'styled-components'

export interface TwoStepPaymentFormContentUiProps {
  padding: PaddingType
  mobilePadding?: PaddingType
  backgroundColor?: string
  mobileBackgroundColor?: string
}

const TwoStepPaymentFormContentUi = styled.div<TwoStepPaymentFormContentUiProps>`
  ${paddingsCss}
  ${backgroundColorCss}
  ${p => p.theme.phone} {
    ${mobilePaddingsCss}
    ${mobileBackgroundColorCss}
  }
  ${p =>
    p.theme.isEditorMobileMode &&
    css`
    ${mobilePaddingsCss}
    ${mobileBackgroundColorCss}
    `}
`

export default TwoStepPaymentFormContentUi
